import { render, staticRenderFns } from "./CasesDetails.vue?vue&type=template&id=6dd30713&scoped=true&"
import script from "./CasesDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CasesDetails.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CasesDetails.vue?vue&type=style&index=0&id=6dd30713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd30713",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd30713')) {
      api.createRecord('6dd30713', component.options)
    } else {
      api.reload('6dd30713', component.options)
    }
    module.hot.accept("./CasesDetails.vue?vue&type=template&id=6dd30713&scoped=true&", function () {
      api.rerender('6dd30713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/components/CasesDetails.vue"
export default component.exports